import React from "react";
import { Badge } from "../../../../components/ui";
import { getNotifications, NotificationsRead } from "../../../../api";
import { Link } from "react-router-dom";
import { formatToLocalDateWithoutTimestamp, formatToLocalDate, getPublisherAvatarUrl } from "utils";
import publisherStore from "../../../../flux/publisherStore";
import { getPublishers } from "../../../../flux/publisherAction";
import "./NotificationsDropdown.scss";

const dateFormatting = (date) => {
  let formattedDate;

  try {
    formattedDate = formatToLocalDateWithoutTimestamp(date);
  } catch (e) {
    formattedDate = formatToLocalDate(date);
  }

  return formattedDate;
};

const TYPE_META = {
  1: { label: "Alert", key: "alert", verb: "shared a new alert" },
  2: { label: "Update", key: "update", verb: "updated an alert" },
  3: { label: "Post", key: "post", verb: "published a new post" },
  4: { label: "Reply", key: "reply", verb: "replied to your comment" },
};

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      disabled: false,
      notifications: [],
      publisherData: publisherStore.getPublishers(),
    };
    this.notificationsPollId = null;
    this.toggleNotifications = this.toggleNotifications.bind(this);
    this.wrapperRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  handleOutsideClick(e) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(e.target)
    ) {
      this.setState({ visible: false });
    }
  }

  getPublisherSmallAvatar = (id) => {
    if (!id || !this.state.publisherData) {
      return null;
    }
    const postPublisher = this.state.publisherData.find(
      (_publisher) => _publisher.id === id,
    );

    if (postPublisher) {
      return getPublisherAvatarUrl(postPublisher) || null;
    }
  };

  refreshNotifications = async () => {
    const data = await getNotifications();
    this.setState({
      notifications: data.data,
    });
  };

  toggleNotifications = async () => {
    const opening = !this.state.visible;
    this.setState({
      visible: opening,
    });

    if (opening) {
      await NotificationsRead();
      this.refreshNotifications();
    }
  };

  closePanel = () => {
    this.setState({ visible: false });
  };

  onChange = () => {
    this.setState({ publisherData: publisherStore.getPublishers() });
  };

  componentDidMount = async () => {
    document.addEventListener("mousedown", this.handleOutsideClick);
    if (localStorage.getItem("user") !== null) {
      let user = JSON.parse(localStorage.getItem("user"));
      const resp = await getNotifications(user.id);
      if (resp !== undefined) {
        this.setState({
          notifications: resp.data,
        });
        this.notificationsPollId = setInterval(async () => {
          const pollResp = await getNotifications(user.id);
          if (pollResp && pollResp.data && pollResp.data) {
            this.setState({
              notifications: pollResp.data,
            });
            pollResp.data.map((a) => {
              if (
                Notification.permission === "granted" &&
                a.consumed === false
              ) {
                new Notification("New alert on Bitcoin.live!", {
                  body: `New alert by ${a.author.name}!`,
                });
              }
            });
          }
        }, 60000);
      }
    } else {
      this.setState({
        disabled: true,
      });
    }
    publisherStore.addChangeListener(this.onChange);
    if (publisherStore.getPublishers().length === 0) getPublishers();
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    publisherStore.removeChangeListener(this.onChange);
    if (this.notificationsPollId != null) {
      clearInterval(this.notificationsPollId);
      this.notificationsPollId = null;
    }
  }

  resolveTypeMeta = (type) =>
    TYPE_META[type] || { label: "Update", key: "update", verb: "sent an update" };

  resolveLink = (post) => {
    if (post.type === 1) {
      return "/alerts/" + post.alertId;
    } else if (post.type === 2) {
      return "/alerts/" + post.alertId;
    } else if (post.type === 3) {
      return post.url;
    } else if (post.type === 4) {
      return post.post.url;
    }
    return "#";
  };

  resolveNotificationCount = () => {
    let count = 0;
    this.state.notifications &&
      this.state.notifications.length > 0 &&
      this.state.notifications.map((data) => {
        if (data.consumed === false) {
          count++;
        }
      });
    return count;
  };

  renderNotificationItem = (post, idx) => {
    const publisher = post && (post.author || post.publisherOrStaff);
    const typeMeta = this.resolveTypeMeta(post.type);
    const avatarUrl = publisher && this.getPublisherSmallAvatar(publisher.id);
    const dateLabel =
      post && (post.publishedAt || post.createdAt)
        ? dateFormatting(post.publishedAt || post.createdAt)
        : null;

    return (
      <Link
        key={idx}
        to={this.resolveLink(post)}
        className="navbar-notifications-panel__item"
        onClick={this.closePanel}
      >
        {avatarUrl ? (
          <div
            className="navbar-notifications-panel__avatar"
            style={{ backgroundImage: `url('${avatarUrl}')` }}
            aria-hidden="true"
          />
        ) : (
          <div className="navbar-notifications-panel__avatar-fallback" aria-hidden="true">
            <i className="material-icons">notifications</i>
          </div>
        )}
        <div className="navbar-notifications-panel__body">
          <div className="navbar-notifications-panel__meta">
            <span
              className={`navbar-notifications-panel__type navbar-notifications-panel__type--${typeMeta.key}`}
            >
              {typeMeta.label}
            </span>
            {dateLabel && (
              <span className="navbar-notifications-panel__date">{dateLabel}</span>
            )}
          </div>
          <p className="navbar-notifications-panel__text">
            {publisher && publisher.name ? (
              <>
                <span className="navbar-notifications-panel__author">
                  {publisher.name}
                </span>{" "}
                {typeMeta.verb}
              </>
            ) : (
              <>New {typeMeta.label.toLowerCase()}</>
            )}
          </p>
        </div>
      </Link>
    );
  };

  render() {
    const unreadCount = this.resolveNotificationCount();
    const hasNotifications =
      this.state.notifications && this.state.notifications.length > 0;

    return (
      <li
        ref={this.wrapperRef}
        className="nav-item dropdown notifications main-navbar-notifications"
      >
        <a
          className="nav-link nav-link-icon text-center main-navbar-notifications__trigger"
          onClick={(e) => {
            e.preventDefault();
            this.toggleNotifications();
          }}
          href="#notifications"
          role="button"
          aria-expanded={this.state.visible}
          aria-haspopup="true"
          aria-label="Notifications"
        >
          <div className="nav-link-icon__wrapper">
            <i className="material-icons">&#xE7F4;</i>
            {hasNotifications && unreadCount > 0 && (
              <Badge
                pill
                theme="danger"
                className="main-navbar-notifications__badge"
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </Badge>
            )}
          </div>
        </a>
        {!this.state.disabled && this.state.visible && (
          <div className="navbar-notifications-panel" role="menu">
            <div className="navbar-notifications-panel__header">
              <h3 className="navbar-notifications-panel__title">Notifications</h3>
              {unreadCount > 0 && (
                <span className="navbar-notifications-panel__count">
                  {unreadCount} new
                </span>
              )}
            </div>

            {hasNotifications ? (
              <div className="navbar-notifications-panel__list">
                {this.state.notifications.map(this.renderNotificationItem)}
              </div>
            ) : (
              <div className="navbar-notifications-panel__empty">
                <i className="material-icons" aria-hidden="true">
                  notifications_none
                </i>
                <p className="navbar-notifications-panel__empty-title">
                  You&apos;re all caught up
                </p>
                <p className="navbar-notifications-panel__empty-desc">
                  No new notifications right now
                </p>
              </div>
            )}

            <Link
              to="/user-profile?tab=notifications"
              className="navbar-notifications-panel__footer"
              onClick={this.closePanel}
            >
              Notification settings
            </Link>
          </div>
        )}
      </li>
    );
  }
}
